var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"architecture-info-right"},[_c('div',{staticClass:"border_corner border_corner_left_top"}),_c('div',{staticClass:"border_corner border_corner_right_top"}),_c('div',{staticClass:"border_corner border_corner_left_bottom"}),_c('div',{staticClass:"border_corner border_corner_right_bottom"})])
}]

export { render, staticRenderFns }